import React, { createContext, createRef, Dispatch, FC, RefObject, useReducer } from 'react';

export const PageContext = createContext<Context>([{ references: {} }, function () {}]);
const { Provider } = PageContext;

export const PageProvider: FC<PageProviderProps> = ({ ids, children }) => {
  const references: Record<string, RefObject<null | number>> = {};

  for (const id of ids) {
    references[id] = createRef();
  }

  const [state, setState] = useReducer(
    (oldState: ContextState, newState: ContextState) => ({ ...oldState, ...newState }),
    { references },
  );

  return <Provider value={[state, setState]}>{children}</Provider>;
};

PageProvider.context = PageContext;

type Context = [ContextState, Dispatch<ContextState>];
type ContextState = { references: Record<string, RefObject<null | number>> };
type PageProviderProps = {
  ids: string[];
};
